import React, { Component } from 'react';

class Portfolio extends Component {
  renderTags(tags) {
    if (!Array.isArray(tags)) {
      return null;
    }

    return tags.map(function(tag) {
      return <span key={tag}>{tag}</span>;
    });
  }

  renderProjects(projects) {
    if (!Array.isArray(projects)) {
      return null;
    }

    return projects.map(function(project) {
      var projectImage = project.image ? 'images/portfolio/' + project.image : null;
      var content = (
        <article className="project-card">
          {projectImage && (
            <div className="project-media">
              <img alt="" src={projectImage} />
            </div>
          )}
          <div className="project-content">
            <p className="project-category">{project.category}</p>
            <h3>{project.title}</h3>
            <p>{project.description}</p>
            {project.impact && <p className="project-impact">{project.impact}</p>}
            <div className="tag-list small">
              {this.renderTags(project.technologies)}
            </div>
          </div>
        </article>
      );

      if (!project.url) {
        return <div key={project.title}>{content}</div>;
      }

      return (
        <a className="project-link" href={project.url} key={project.title} target="_blank" rel="noreferrer">
          {content}
        </a>
      );
    }.bind(this));
  }

  render() {
    var data = this.props.data || {};

    return (
      <section id="portfolio" className="section portfolio-section">
        <div className="section-heading">
          <p className="eyebrow">Selected Work</p>
          <h2>Practical data products and platforms with measurable business value.</h2>
        </div>

        <div className="project-grid">
          {this.renderProjects(data.projects)}
        </div>
      </section>
    );
  }
}

export default Portfolio;
